export class NotFoundException extends Error {}
